import React, { useEffect } from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import styles from "../../../../styles/global-styles";
import { connect } from "react-redux";
import { actions } from "../../../../redux/actions/alert";
import CreateImeiForm from "../forms/CreateImeiForm";

const usetSyles = makeStyles((theme) => ({
  form: {
    width: "auto", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  formControl: {
    marginTop: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      width: 240,
    },
    [theme.breakpoints.down("sm")]: {
      width: 250,
    },
    minWidth: 200,
    width: 320,
  },
  label: {
    marginBottom: "1.5vh",
  },
  inputBoxSpace: styles.inputBoxSpace,
  backgroundIcon: styles.backgroundIcon,
  box: {
    marginTop: "30px",
  },
}));

const AddToInventory = ({
  detailProduct,
  productsCreated,
  addAlert,
  detailAlert,
}) => {
  useEffect(() => {
    console.log("detailProduct for new form", detailProduct);
    if (Object.values(detailProduct).length > 0) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "success",
        message: "Equipo móvil creado exitosamente",
      });
    }
  }, []);

  return (
    <React.Fragment>
      <Grid container direction="row" justify="flex-start" alignItems="center">
        <Grid item xs={12}>
          <Typography
            variant="h4"
            style={{ fontWeight: "bold" }}
            component={"div"}
          >
            Modelo {detailProduct.brand} {detailProduct.model}
          </Typography>
          <Typography variant="body1" gutterBottom>
            Memoria RAM {detailProduct.capacity} Gigabytes.
          </Typography>
        </Grid>

        <CreateImeiForm
          isNewStock={false}
          detailProduct={detailProduct}
          productsCreated={productsCreated}
        />
      </Grid>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(AddToInventory);
